import React, { useState, useEffect } from "react";
import BackBtn from "../components/BackBtn";
import SaveBadge from "../components/SaveBadge";
import ChipEditor from "../components/ChipEditor";
import Pill from "../components/Pill";
import { DiagramButton } from "../components/Diagram";
import { Segmented, WeekNav } from "../components/ui";
import { hasPlanning, mondayOfWeek, fmtRange } from "../lib/planning";
import { FF, T } from "../lib/constants";
import { lessonBlocks, blocksMinutes, fmtDur } from "../lib/blocks";
import LessonStructure from "../components/LessonStructure";

// Lessen waarvoor de lesopbouw al automatisch is getoond (één keer per sessie).
var autoShown = {};

// Lesscherm (build 2.2): de weeknavigatie staat nu bovenaan (pijltjes + "Week N"),
// in plaats van het donkere weekblok en de weekknoppen onderaan.
export default function Lesson({
  mob, pd, lv, sel, selW, data, wks, tab, sav, savLabel, canEdit, planning,
  setSelW, setTab, setScr,
  setField, setEx, setExtras, setWeekTags, openTimeEdit, setLesson,
  renderModal, renderNotes,
}) {
  var wd = (data && sel && selW) ? (data[sel] ? data[sel][selW] : null) : null;
  var [structOpen, setStructOpen] = useState(false);
  var lesK = tab === 1 ? "lessonB" : "lessonA";
  var curLes = wd ? wd[lesK] : null;
  var emptyLes = !!curLes && !curLes.order && lessonBlocks(curLes).every(function (b) {
    var d = b.data; return !((d.description && d.description.trim()) || (d.accents && d.accents.length) || d.diagram);
  });
  // Nieuwe (lege) les: de editor krijgt de lesopbouw meteen te zien.
  useEffect(function () {
    var id = sel + ":" + selW + ":" + lesK;
    if (canEdit && setLesson && emptyLes && !autoShown[id]) { autoShown[id] = true; setStructOpen(true); }
  }, [sel, selW, lesK, canEdit, emptyLes, setLesson]);
  if (!wd) return null;

  var lesKeys = [{ key: "lessonA", label: mob ? "Les A" : "Les A — Training 1" }, { key: "lessonB", label: mob ? "Les B" : "Les B — Training 2" }];
  var curL = lesKeys[tab];
  var lesData = wd[curL.key];
  var ci = wks.indexOf(selW);
  var prev = ci > 0 ? wks[ci - 1] : null;
  var next = ci < wks.length - 1 ? wks[ci + 1] : null;
  var ink = lv.ink || lv.color;
  var wkMonday = hasPlanning(planning) ? mondayOfWeek(planning, selW) : null;
  var weekSub = wkMonday ? fmtRange(wkMonday) : "van " + wks.length;
  var label = { fontSize: 11, fontWeight: 700, letterSpacing: 0.6, textTransform: "uppercase", color: ink, whiteSpace: "nowrap" };
  var inputBase = { border: "1px solid " + T.line, borderRadius: 8, outline: "none", fontFamily: FF, color: T.ink, background: "#fff" };

  return (
    <div style={{ maxWidth: 1100, margin: "0 auto", padding: "12px " + pd + "px 48px", fontFamily: FF }}>
      <SaveBadge show={sav} label={savLabel} />
      <BackBtn label={lv.label + " — alle weken"} onClick={function () { setScr("weeks"); }} />

      <div style={{ maxWidth: 380, margin: "0 auto 16px" }}>
        <WeekNav week={selW} sub={weekSub} big={!mob}
          onPrev={prev ? function () { setSelW(prev); setTab(0); } : null}
          onNext={next ? function () { setSelW(next); setTab(0); } : null} />
      </div>

      <article style={{ background: T.card, borderRadius: 18, border: "1px solid " + T.line2, overflow: "hidden" }}>
        <div style={{ background: lv.color, color: lv.on || "#fff", padding: mob ? "12px 16px" : "14px 22px", display: "flex", alignItems: "baseline", justifyContent: "space-between", gap: 12 }}>
          <span style={{ fontWeight: 800, fontSize: mob ? 20 : 22 }}>{lv.label}</span>
          <span style={{ fontSize: 13, whiteSpace: "nowrap" }}>{"Week " + selW + " / " + wks.length}</span>
        </div>

        <div style={{ padding: mob ? "14px 16px" : "16px 22px", borderBottom: "1px solid " + T.line }}>
          {canEdit
            ? (<div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                <input value={wd.title} onChange={function (e) { setField("title", e.target.value); }} placeholder="Titel van de week" style={Object.assign({}, inputBase, { padding: "8px 12px", fontSize: mob ? 18 : 21, fontWeight: 800, width: "100%" })} />
                <input value={wd.subtitle || ""} onChange={function (e) { setField("subtitle", e.target.value); }} placeholder="Subtitel" style={Object.assign({}, inputBase, { padding: "6px 12px", fontSize: 13, color: T.muted, width: "100%" })} />
              </div>)
            : (<div>
                <h1 style={{ fontWeight: 800, fontSize: mob ? 21 : 25, lineHeight: 1.2, color: wd.title ? T.ink : "#B5B0A6" }}>{wd.title || "Nog niet ingevuld"}</h1>
                {wd.subtitle && <p style={{ fontSize: 14, color: T.muted, marginTop: 2 }}>{wd.subtitle}</p>}
              </div>)}
        </div>

        <div style={{ padding: "10px " + (mob ? 16 : 22) + "px", borderBottom: "1px solid " + T.line, display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
          <h4 style={label}>Tags</h4>
          {canEdit
            ? <div style={{ flex: 1, minWidth: 160 }}><ChipEditor items={wd.tags || []} onChange={setWeekTags} placeholder="Tag toevoegen..." color={ink} /></div>
            : (wd.tags && wd.tags.length > 0 ? wd.tags.map(function (t, i) { return <span key={i} style={{ fontSize: 11, fontWeight: 700, padding: "2px 9px", borderRadius: 10, background: lv.bg, color: ink, border: "1px solid " + lv.border }}>{t}</span>; }) : <span style={{ fontSize: 12, color: "#B5B0A6" }}>—</span>)}
        </div>

        <div style={{ display: mob ? "block" : "grid", gridTemplateColumns: "1fr 1fr", borderBottom: "1px solid " + T.line, background: lv.bg }}>
          {[["theme", "Thema & focus"], ["adjustments", "Groepsaanpassingen"]].map(function (pair, i) {
            return (
              <div key={pair[0]} style={{ padding: "12px " + (mob ? 16 : 22) + "px", borderRight: !mob && i === 0 ? "1px solid " + lv.border : "none", borderBottom: mob && i === 0 ? "1px solid " + lv.border : "none" }}>
                <h4 style={Object.assign({}, label, { marginBottom: 4 })}>{pair[1]}</h4>
                {canEdit
                  ? <textarea value={wd[pair[0]]} onChange={function (e) { setField(pair[0], e.target.value); }} placeholder="..." rows={3} style={Object.assign({}, inputBase, { width: "100%", padding: 8, fontSize: 13, lineHeight: 1.6, resize: "vertical", color: "#4A4740" })} />
                  : <p style={{ fontSize: 13, lineHeight: 1.6, color: "#4A4740", whiteSpace: "pre-line" }}>{wd[pair[0]] || "—"}</p>}
              </div>
            );
          })}
        </div>

        <div style={{ padding: "12px " + (mob ? 16 : 22) + "px", borderBottom: "1px solid " + T.line, display: "flex", alignItems: "center", gap: 10 }}>
          <Segmented value={tab} onChange={setTab} options={lesKeys.map(function (l, i) { return { value: i, label: l.label }; })} style={{ maxWidth: 460, flex: 1, minWidth: 0 }} />
          {canEdit && setLesson && (
            <button type="button" onClick={function () { setStructOpen(true); }} aria-label={"Lesopbouw " + (tab === 1 ? "Les B" : "Les A")}
              style={{ flex: "none", minHeight: 40, padding: mob ? "0 12px" : "0 14px", borderRadius: 10, border: "1px solid " + T.line, background: "#fff", color: T.primary, fontSize: 14, fontWeight: 700, fontFamily: FF, cursor: "pointer", whiteSpace: "nowrap" }}>{mob ? "☰ Opbouw" : "☰ Lesopbouw"}</button>
          )}
          {!mob && <span style={{ fontSize: 13, fontWeight: 700, color: T.muted, whiteSpace: "nowrap", marginLeft: "auto" }}>{"Totaal " + fmtDur(blocksMinutes(lesData), "min")}</span>}
        </div>

        <div>
          {lessonBlocks(lesData, lv).map(function (ex) {
            var exd = ex.data;
            return (
              <div key={ex.key} style={{ display: "grid", gridTemplateColumns: mob ? "56px 1fr" : "72px 1fr auto", borderBottom: "1px solid " + T.line, minHeight: 76, background: ex.tint || "transparent" }}>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "flex-start", gap: 6, padding: "14px 4px" }}>
                  <div style={{ width: 32, height: 32, borderRadius: 16, background: ex.bg, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, fontSize: 14, color: ex.fg }}>{ex.icon}</div>
                  {canEdit
                    ? <button onClick={function () { openTimeEdit(curL.key, ex.key); }} style={{ minWidth: 42, height: 30, textAlign: "center", border: "1px solid " + T.line, borderRadius: 8, fontSize: 12, padding: "0 4px", color: T.ink, fontWeight: 700, fontFamily: FF, background: T.soft, cursor: "pointer" }}>{fmtDur(exd.time)}</button>
                    : <span style={{ fontSize: 12, fontWeight: 700, color: T.muted }}>{fmtDur(exd.time, "min")}</span>}
                </div>
                <div style={{ padding: mob ? "12px 14px 12px 4px" : "12px 18px 12px 4px", minWidth: 0 }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, marginBottom: 4 }}>
                    <div style={{ fontSize: 11, fontWeight: 700, color: T.muted, textTransform: "uppercase", letterSpacing: 0.6 }}>{ex.label}</div>
                    <DiagramButton diagram={exd.diagram} canEdit={canEdit} title={ex.label}
                      onSave={function (v) { setEx(curL.key, ex.key, "diagram", v); }} />
                  </div>
                  {canEdit
                    ? (<div>
                        <textarea value={exd.description} onChange={function (e) { setEx(curL.key, ex.key, "description", e.target.value); }} placeholder="Uitleg..." rows={2} style={Object.assign({}, inputBase, { width: "100%", padding: 8, fontSize: 13, lineHeight: 1.5, resize: "vertical", color: "#4A4740", marginBottom: 6 })} />
                        <div style={{ marginBottom: 4 }}><span style={{ fontSize: 11, color: T.muted, fontWeight: 600 }}>Accenten:</span></div>
                        <ChipEditor items={exd.accents || []} onChange={function (v) { setEx(curL.key, ex.key, "accents", v); }} placeholder="Accent toevoegen..." color={ex.ink} />
                      </div>)
                    : (<div>
                        {/* Oefeningtitels worden niet meer gebruikt; het streepje blijft als rustpunt. */}
                        <h3 aria-hidden="true" style={{ fontWeight: 700, fontSize: 16, color: "#B5B0A6", marginBottom: 3 }}>—</h3>
                        {exd.description && <p style={{ fontSize: 13, lineHeight: 1.55, color: "#4A4740", whiteSpace: "pre-line" }}>{exd.description}</p>}
                        {mob && exd.accents && exd.accents.length > 0 && <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginTop: 8 }}>{exd.accents.map(function (a, i) { return <Pill key={i} text={a} clr={ex.ink} />; })}</div>}
                      </div>)}
                </div>
                {!canEdit && !mob && exd.accents && exd.accents.length > 0 && (<div style={{ padding: "14px 18px", display: "flex", flexDirection: "column", gap: 4, justifyContent: "flex-start", alignItems: "flex-end", minWidth: 130, maxWidth: 340 }}>{exd.accents.map(function (a, i) { return <Pill key={i} text={a} clr={ex.ink} />; })}</div>)}
              </div>
            );
          })}
        </div>

        {/* Het oude vak "Extra oefeningen" is vervangen door het blok Extra oefening in de
            lesopbouw (build 2.6). Staat er nog oude tekst in, dan ziet alleen de editor het
            vak, zodat hij de tekst kan verplaatsen; leeg = weg. */}
        {canEdit && extrasText(wd.extras) && (
          <div style={{ padding: "12px " + (mob ? 16 : 22) + "px", background: lv.bg }}>
            <h4 style={Object.assign({}, label, { marginBottom: 2 })}>Extra oefeningen (oud)</h4>
            <p style={{ fontSize: 12, color: T.muted, margin: "0 0 6px" }}>Alleen jij ziet dit vak. Zet de tekst in een blok via Lesopbouw en maak het vak leeg; dan verdwijnt het.</p>
            <textarea value={(wd.extras || []).join("\n")} onChange={function (e) { setExtras(e.target.value.split("\n")); }} placeholder="..." rows={3} style={Object.assign({}, inputBase, { width: "100%", padding: 8, fontSize: 13, lineHeight: 1.6, resize: "vertical", color: "#4A4740" })} />
          </div>
        )}
      </article>
      {renderNotes && <div style={{ marginTop: 14 }}>{renderNotes(lv, selW, tab)}</div>}
      {renderModal()}
      {structOpen && curLes && (
        <LessonStructure mob={mob} les={curLes} lv={lv} sub={lv.label + " · week " + selW + " · " + (tab === 1 ? "Les B" : "Les A")}
          onClose={function () { setStructOpen(false); }}
          onSave={function (n) { setLesson(lesK, n); setStructOpen(false); }} />
      )}
    </div>
  );
}

// Lijst regels -> leesbare tekst (lege regels aan begin/eind weg).
export function extrasText(extras) {
  return (extras || []).join("\n").replace(/^\s+|\s+$/g, "");
}
